const UPDATE_BONUS_PERIOD_STATUS: FleetOps.Permission =
  'fleetops.permissions.driver_bonus_update_bonus_period_status';
const INCLUDE_EXCLUDE_RECORDS: FleetOps.Permission =
  'fleetops.permissions.driver_bonus_include_exclude_records';
const EXCLUSIONS_WRITE: FleetOps.Permission =
  'fleetops.permissions.driver_bonus_exclusions_write';
const OVERRIDE_CATEGORIES: FleetOps.Permission =
  'fleetops.permissions.driver_bonus_override_categories';
const SIGN_OFF: FleetOps.Permission =
  'fleetops.permissions.driver_bonus_sign_off';
const DRIVER_APP_ADMIN: FleetOps.Permission =
  'fleetops.permissions.driver_app_admin';
const DRIVER_BONUS_INVITE: FleetOps.Permission =
  'fleetops.permissions.driver_bonus_invite';
const ADDITIONAL_PAYMENTS: FleetOps.Permission =
  'fleetops.permissions.driver_bonus_additional_payments';

const DRIVER_BONUS_PERMISSIONS = {
  UPDATE_BONUS_PERIOD_STATUS,
  INCLUDE_EXCLUDE_RECORDS,
  EXCLUSIONS_WRITE,
  OVERRIDE_CATEGORIES,
  SIGN_OFF,
  DRIVER_APP_ADMIN,
  DRIVER_BONUS_INVITE,
  ADDITIONAL_PAYMENTS,
};
Object.freeze(DRIVER_BONUS_PERMISSIONS);

export default DRIVER_BONUS_PERMISSIONS;
